import { confirmMes } from '@/shared/utilities';
import { useCallback, useEffect, useState } from 'react';
import { chatEE } from '../../../layout/events/chat-event-emitter';

export const useMemberAddDialog = () => {
  const [show, setShow] = useState(false);
  const [conversationId, setConversationId] = useState<string>('');

  useEffect(() => {
    const openHandler = (convId: string) => {
      setConversationId(convId);
      setShow(true);
    };
    chatEE.on('add-member', openHandler);
    return () => {
      chatEE.off('add-member', openHandler);
    };
  }, []);

  const handleClose = useCallback(async (hasUnsavedChanges: boolean, handleReset: () => void) => {
    if (hasUnsavedChanges) {
      const confirm = await confirmMes({
        title: 'Xác nhận',
        description: 'Bạn có dữ liệu chưa lưu. Bạn có chắc muốn đóng?'
      });
      if (!confirm) return;
    }
    setShow(false);
    setConversationId('');
    handleReset();
  }, []);

  return {
    show,
    setShow,
    conversationId,
    handleClose
  };
};
